export default "__VITE_PUBLIC_ASSET__ae941a6d__"